export default __webpack_public_path__ + "static/media/Cyberwagon.256.ce1a2ae8.png";